module.exports = __webpack_public_path__ + "img/00006.ec84c363.webp";